import React, { useState } from 'react';
import { Container, Row, Col, Card, Button, Modal } from 'react-bootstrap';
import { urlApi, storageUrl } from '../Constants/Global';
import NoPhoto from '../Medias/Photos/1655820470_0.webp';
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import Photo1 from '../Medias/Photos/client1.png';
import Public1 from '../Medias/Photos/1672481410_0.jpg';
import File1 from '../Medias/Photos/1672481281_0.pdf';
import Public2 from '../Medias/Docs/power-of-the-act-cover.png';
import File2 from '../Medias/Docs/power-of-the-act.pdf';
import Public3 from '../Medias/Docs/20230301_1.png';
import File3 from '../Medias/Docs/20230301_1.pdf';
import Public4 from '../Medias/Docs/20230301_2.png';
import File4 from '../Medias/Docs/20230301_2.pdf';
import Public5 from '../Medias/Docs/20230301_3.png';
import File5 from '../Medias/Docs/20230301_3.pdf';
import Public6 from '../Medias/Docs/2025-03-16.png';
import File6 from '../Medias/Docs/2025-03-16.pdf';
import Public7 from '../Medias/Docs/20250405_cover.png';
import File7 from '../Medias/Docs/20250405_publication.pdf';
import Public8 from '../Medias/Docs/tokenized.png';
import File8 from '../Medias/Docs/tokenized.pdf';
import Public9 from '../Medias/Docs/tok.png';
import File9 from '../Medias/Docs/tok.pdf';
import Public10 from '../Medias/Docs/EnergyTransition_PE13May2025.png';
import File10 from '../Medias/Docs/EnergyTransition_PE13May2025.pdf';
import Public11 from '../Medias/Docs/doc_2025-06.png';
import File11 from '../Medias/Docs/doc_2025-06.pdf';
import Public12 from '../Medias/Docs/Corruption-in-the-Energy.png';
import File12 from '../Medias/Docs/Corruption-in-the-Energy.pdf';
import Public13 from '../Medias/Docs/2025-09-07.png';
import File13 from '../Medias/Docs/2025-09-07.pdf';

const SectionPublication = ({ contents, youtubes }) => {
  // console.log('Load Publication :', contents);

  const [visibleItems, setVisibleItems] = useState(6);
  const [showModal, setShowModal] = useState(false);
  const [selectedContent, setSelectedContent] = useState(null);

  const loadMoreItems = () => {
    setVisibleItems(prevVisibleItems => prevVisibleItems + 6);
  };

  const handleViewContent = (content) => {
    setSelectedContent(content);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedContent(null);
  };

  const mockup = [
    // {
    //   name: 'Power of The Act: เมืองอัจฉริยะและโอกาสทางธุรกิจสำหรับนักพัฒนาเมือง',
    //   tags: 'Power of The Act',
    //   row_value: Photo1
    // },
    // {
    //   name: 'Power of The Act: เมืองอัจฉริยะและโอกาสทางธุรกิจสำหรับนักพัฒนาเมือง',
    //   tags: 'Power of The Act',
    //   row_value: NoPhoto
    // },
    // {
    //   name: 'Power of The Act: เมืองอัจฉริยะและโอกาสทางธุรกิจสำหรับนักพัฒนาเมือง',
    //   tags: 'Power of The Act',
    //   row_value: NoPhoto
    // },
    // {
    //   name: 'Power of The Act: เมืองอัจฉริยะและโอกาสทางธุรกิจสำหรับนักพัฒนาเมือง',
    //   tags: 'Power of The Act',
    //   row_value: NoPhoto
    // },
    // {
    //   name: 'Power of The Act: เมืองอัจฉริยะและโอกาสทางธุรกิจสำหรับนักพัฒนาเมือง',
    //   tags: 'Power of The Act',
    //   row_value: NoPhoto
    // },
    // {
    //   name: 'Power of The Act: เมืองอัจฉริยะและโอกาสทางธุรกิจสำหรับนักพัฒนาเมือง',
    //   tags: 'Power of The Act',
    //   row_value: NoPhoto
    // },
  ];

  const mockup2 = [
    {
      name: 'กฎหมาย (พลังงาน) เพื่อการเปลี่ยนผ่าน (ทางพลังงาน): โอกาสและความท้าทายของผู้ผลิตไฟฟ้าไทย',
      tags: 'Publications',
      row_value: Public13,
      row_file: File13
    },
    {
      name: 'การวิเคราะห์ผลกระทบกฎหมายที่เกี่ยวกับการทุจริต',
      tags: 'Publications',
      row_value: Public12,
      row_file: File12
    },
    {
      name: 'แนวทางปฏิบัติที่ดีเกี่ยวกับระยะถอยร่น (Set Back) และมาตรการเพื่อความปลอดภัยของโครงการพลังงานลม และการพัฒนากฎหมายเพื่อกำกับดูแลกำหนดระยะห่างที่ตั้งโครงการผลิตไฟฟ้าจากพลังงานลม',
      tags: 'Publications',
      row_value: Public11,
      row_file: File11
    },
    {
      name: 'Thailand\'s Energy Transition in 2025 Reflections, Projections and Aspirations',
      tags: 'Publications',
      row_value: Public10,
      row_file: File10
    },
    {
      name: 'ข้อความคิดพื้นฐานและลักษณะทางกฎหมายของ (tokenized) carbon credit, REC, carbon allowance',
      tags: 'Publications',
      row_value: Public9,
      row_file: File9
    },
    {
      name: 'เอกสารประกอบการบรรยายในหัวข้อ ข้อความคิดพื้นฐานและลักษณะทางกฎหมายของ (tokenized) carbon credit, REC, carbon allowance',
      tags: 'Publications',
      row_value: Public8,
      row_file: File8
    },
    {
      name: 'ลักษณะความเป็นทรัพย์สินและสินทรัพย์ของ (tokenized) Renewable Energy Certificate (REC) ในระบบกฎหมายไทย',
      tags: 'Publications',
      row_value: Public7,
      row_file: File7
    },
    {
      name: 'Stability of petroleum contracts (PSC) in Indonesia : Theory and practice',
      tags: 'Publications',
      row_value: Public6,
      row_file: File6
    },
    {
      name: 'การกำกับกิจการปิโตรเลียมอย่างเป็นธรรม',
      tags: 'Publications',
      row_value: Public5,
      row_file: File5
    },
    {
      name: 'เร่งเพิ่มสัดส่วนพลังงานสะอาดเพื่อค่าไฟที่เป็นธรรมและทันท่วงที',
      tags: 'Publications',
      row_value: Public4,
      row_file: File4
    },
    {
      name: 'Integrating EV charging with renewable energy : Policies and implementation',
      tags: 'Publications',
      row_value: Public3,
      row_file: File3
    },
    {
      name: 'รวมบทความ Power of the Act',
      tags: 'Publications',
      row_value: Public2,
      row_file: File2
    },
    {
      name: 'รวมบทความ Power of the Act 2022',
      tags: 'Publications',
      row_value: Public1,
      row_file: File1
    },
  ];

  return (
    <>
      <section id="knowledge" className='pt-5 pb-5'>
        <Container className='pt-5 pb-5'>
          <Row>
            {mockup2.map((item, index) => (
              <Col md={4} key={index} className='px-4 mx-auto'>
                <Card className='rounded-0 shadow border-0 mb-5'>
                  <Card.Img className='rounded-0' src={item.row_value} />
                  <Card.Body>
                    <h5 className='text-black text-uppercase mb-1'>{item.name}</h5>
                    <h6 className='mt-3 mb-1 tx-color-primary'>
                      {item.tags}
                      <a href={item.row_file} className='tx-color-primary' target='_blank'>
                        <span className='float-end'><MdKeyboardDoubleArrowRight /> Read More</span>
                      </a>
                    </h6>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </>
  )
}

SectionPublication.defaultProps = {
  contents: [],
  youtubes: []
}

export default SectionPublication